module.exports = __webpack_public_path__ + "3f9d53636dd1e005d5e92d8e540c343a.pdf";